<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb v-show="routemeta.navbar" />
    <div class="container-xl">
      <div class="border-0 text-container-wider">
          <h1 class="text-primary">
            Hi {{ this.$store.state.user.first_name }} {{ this.$store.state.user.family_name }}!
          </h1>
          <b-row class="mx-0 px-0">
            <div class="mx-0 px-0 col-xs-12 col-8">
              Welcome to the GDQ Learning Hub.
              <p class="mx-0 px-0 mt-4">
                Here you will find all courses offered by GDQ Associates. You can register for courses, follow the progress in your learning journey or review materials from completed courses.
              </p>
            </div>
            <div class="mx-0 px-0 col-xs-12 col-4 text-right text-top">
              <b-button>Contact your tutor</b-button>
            </div>
          </b-row>
          <h3
            class="pt-4 mt-4"
            style="border-top: 1px solid black"
          >
            Courses
          </h3>
          <b-table
            class="mx-0 px-0 mb-4"
            :items="courses"
            :busy="loading"
            :fields="coursesColumns"
            :per-page="coursesPerPage"
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
              <b-spinner class="align-middle mr-2" />
              <strong>Loading...</strong>
            </div>
            </template>
            <template v-slot:cell(location)="data">
              {{ data.item.course_location }}
            </template>
            <template v-slot:cell(actions)="data">
              <b-dropdown right class="w-100">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item
                  v-show="data.item.status == 'Not started'"
                >
                  <b-link
                    :to="`/elearningcourse/${data.item.id}/0`"
                  >
                    Start
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="data.item.status == 'Available'"
                >
                  Apply
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="data.item.status == 'In progress'"
                >
                  <b-link
                    :to="`/elearningcourse/${data.item.id}/0`"
                  >
                    Continue
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="data.item.status == 'Completed'"
                >
                  <b-link
                    :to="`/elearningcourse/${data.item.id}/0`"
                  >
                    Continue
                  </b-link>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <h3
            class="pt-4 mt-4"
            style="border-top: 1px solid black"
          >
            My certificates
          </h3>
          <b-table
            class="mx-0 px-0"
            :items="certificates"
            :fields="certificatesColumns"
            :per-page="certificatesPerPage"
          >
          </b-table>
      </div>
    </div>
  </div>
</template>
<script>

import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

export default {
  name: 'LearningHub',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      routemeta: this.$route.meta,
      coursesColumns: [
        { key: 'id', sortable: true, label: 'ID', tdClass: 'd-none', thClass: 'd-none' },
        { key: 'course_name', sortable: true, label: 'Name' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'course_location', sortable: true, label: 'Location' },
        { key: 'course_start', sortable: true, sortable: true, label: 'Start date' },
        { key: 'course_end', sortable: true, sortable: true, label: 'End date' },
        { key: 'progress', sortable: true, label: 'Progress' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      coursesPerPage: 5,
      courses: [],
      certificatesColumns: [],
      certificatesPerPage: 5,
      certificates: [],
      emptyImage: `data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNsqAcAAYUBAdpOiIkAAAAASUVORK5CYII=`,
      loading: true
    }
  },
  computed: {
  },
  async created () {
    this.courses_get()
  },
  methods: {
    course_set (id) {
      this.$store.dispatch('currentcourse_id_setcurrent', { course_id: id })
      this.$router.push({ path: '/elearningcourse/' + id })
    },
    async courses_get () {
      this.loading = true
      const filter = {
        course_active: {
          operator: '=',
          value: 1
        }
      }
      await this.$store.dispatch('elearning_consultant_getcourses', { consultant_id: this.$store.state.user.id })
        .then(async (resp) => {
          let outCourses = []
          let courses = resp.data.result
          for (let i = 0; i < courses.length; i++) {
            const course =
              {
                ...courses[i],
                progress: courses[i].status == 'Available' ? '' : `${courses[i].modules_done} / ${courses[i].number_modules}`,
                course_start: courses[i].course_start < '1971-01-01' ? '' : courses[i].course_start,
                course_end: courses[i].course_end < '1971-01-01' ? '' : courses[i].course_end
              }
            outCourses.push(course)
          }
          this.courses = outCourses
        })
      this.loading = false
    }
  }
}
</script>
<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp, 5);
  -webkit-box-orient: vertical;
  word-break: var(--word-break, 'none');
  overflow: hidden;
  hyphens: auto;
  text-align: var(--align, left);
  --is-single-line: 1 - Clamp(0, Calc(var(--line-clamp) - 1), var(--line-clamp));
  --delay: Calc(-1s * (var(--is-single-line, 1) - 1));
  animation: states 1s var(--delay) paused;

  @keyframes states {
      0% { word-break: break-all; }
  }
  .text-container-wider {
    min-width: 1246px !important;
    margin: 0 auto;
  }
}
</style>
